import script from "./GiftPageDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftPageDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./GiftPageDetailsPopup.vue?vue&type=style&index=0&id=6e610564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e610564"]])

export default __exports__